import enAssets from './locales/en-US/assets.json'
import enCommon from './locales/en-US/common.json'
import enFooter from './locales/en-US/footer.json'
import enHome from './locales/en-US/home.json'
import enLegal from './locales/en-US/legal.json'
import enLogin from './locales/en-US/login.json'
import enNav from './locales/en-US/nav.json'
import enNotFound from './locales/en-US/notFound.json'
import enSupport from './locales/en-US/support.json'

import zhAssets from './locales/zh-CN/assets.json'
import zhCommon from './locales/zh-CN/common.json'
import zhFooter from './locales/zh-CN/footer.json'
import zhHome from './locales/zh-CN/home.json'
import zhLegal from './locales/zh-CN/legal.json'
import zhLogin from './locales/zh-CN/login.json'
import zhNav from './locales/zh-CN/nav.json'
import zhNotFound from './locales/zh-CN/notFound.json'
import zhSupport from './locales/zh-CN/support.json'

export const enUS = {
  ...enCommon,
  ...enNav,
  ...enFooter,
  ...enHome,
  ...enSupport,
  ...enLogin,
  ...enAssets,
  ...enNotFound,
  ...enLegal,
}

export const zhCN = {
  ...zhCommon,
  ...zhNav,
  ...zhFooter,
  ...zhHome,
  ...zhSupport,
  ...zhLogin,
  ...zhAssets,
  ...zhNotFound,
  ...zhLegal,
}
